import { render, staticRenderFns } from "./merchant-public-account.vue?vue&type=template&id=340de06a&scoped=true"
import script from "./merchant-public-account.vue?vue&type=script&lang=js"
export * from "./merchant-public-account.vue?vue&type=script&lang=js"
import style0 from "./merchant-public-account.vue?vue&type=style&index=0&id=340de06a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "340de06a",
  null
  
)

export default component.exports